import { makeAutoObservable } from "mobx";
import Proveedor from "../api/proveedor/proveedor";
import { getError } from "../util/util";

export class ProveedorStore {
  rootStore;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  loading = false;
  entities = [];

  filter = undefined;
  setFilter = (value) => {
    this.filter = value;
  };

  getAll = async (showAlert = false) => {
    this.showLoading();
    try {
      const result = await Proveedor.getAll();
      if (result.success) {
        this.entities = result.data;
        if (result.data && result.data.length <= 0 && showAlert) {
          this.rootStore.alertStore.alertError("No se encontraron resultados");
        }
      }
      return Promise.resolve(true);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(false);
    } finally {
      this.hideLoading();
    }
  };

  getAllByFilter = async (data) => {
    this.showLoading();
    try {
      const result = await Proveedor.getAllByFilter(data);
      if (result.success) {
        this.entities = result.data;
        if (result.data && result.data.length <= 0) {
          this.rootStore.alertStore.alertError("No se encontraron resultados");
        }
      }
    } catch (error) {
      this.displayError(error);
    } finally {
      this.hideLoading();
    }
  };

  activeOrInactive = async (data) => {
    this.showLoading();
    try {
      const result = await Proveedor.activeOrInactive(data);
      if (result.success) this.getAllOrFilter();

      this.rootStore.alertStore.alertUpdateSuccess();
    } catch (error) {
      this.displayError(error);
    } finally {
      this.hideLoading();
    }
  };

  create = async (data) => {
    this.showLoading();
    try {
      const result = await Proveedor.create(data);
      if (result.success) {
        if (
          result.data &&
          result.data?.validations &&
          result.data?.validations.length > 0
        ) {
          return Promise.resolve(result.data?.validations);
        } else {
          this.getAllOrFilter();
          this.rootStore.alertStore.alertCreateSuccess();
          return Promise.resolve(null);
        }
      }
    } catch (error) {
      this.displayError(error);
      return Promise.error(null);
    } finally {
      this.hideLoading();
    }
  };

  update = async (data) => {
    this.showLoading();
    try {
      const result = await Proveedor.update(data);
      if (result.success) {
        if (
          result.data &&
          result.data?.validations &&
          result.data?.validations.length > 0
        ) {
          return Promise.resolve(result.data?.validations);
        } else {
          this.getAllOrFilter();
          this.rootStore.alertStore.alertUpdateSuccess();
          return Promise.resolve(null);
        }
      }
      return Promise.resolve();
    } catch (error) {
      this.displayError(error);
      return Promise.error(null);
    } finally {
      this.hideLoading();
    }
  };

  sendCode = async (id) => {
    this.showLoading();
    try {
      const result = await Proveedor.sendCode(id);
      if (result.success) this.getAllOrFilter();

      this.rootStore.alertStore.alertCreateSuccess("Enviado exitosamente");
    } catch (error) {
      this.displayError(error);
    } finally {
      this.hideLoading();
    }
  };

  newCode = async (id) => {
    this.showLoading();
    try {
      const result = await Proveedor.newCode(id);
      if (result.success) this.getAllOrFilter();

      this.rootStore.alertStore.alertCreateSuccess("Generado exitosamente");
    } catch (error) {
      this.displayError(error);
    } finally {
      this.hideLoading();
    }
  };

  deleteProveedor = async (id) => {
    this.showLoading();
    try {
      const result = await Proveedor.delete(id);
      if (result.success) this.getAllOrFilter();

      this.rootStore.alertStore.alertDeleteSuccess();
      return Promise.resolve();
    } catch (error) {
      this.displayError(error);
    } finally {
      this.hideLoading();
    }
  };

  getAllOrFilter = () => {
    if (this.filter && this.filter?.value) {
      this.getAllByFilter(
        this.filter?.value !== 1 ? { IdEstatus: this.filter?.value } : {}
      );
    } else {
      this.getAll();
    }
  };

  showLoading = () => {
    this.rootStore.logisticBackdropStore.openLoading();
  };

  hideLoading = () => {
    this.rootStore.logisticBackdropStore.closeLoading();
  };

  displayError = (error) => {
    this.rootStore.alertStore.alertError(getError(error));
  };
}
